export default "__VITE_ASSET__81a9f0ca__$_?nuxt_component=async__"